/**
 * Opens a BOQ's print view (`/boqs/:boqId/print`) in a new tab, so the page
 * the person was on stays as it was.
 */
export function openBoqPrintView(boqId: string): void {
	window.open(`/boqs/${boqId}/print`, "_blank", "noopener");
}
